
<div>
  <strong>Manage Licensee & Administrators</strong> / 
</div>
<hr class="hrDiv">
<div class="page-container">
  <div class="topSectnDiv">
    <div class="floatLeft">
      <h1>Manage RBRVS DataManager Users</h1><br>
      <p class="introCls" [innerHTML]='introMessage'></p>
    </div>
    
  </div>
  <div *ngIf="!loaded || !usersLoadingComplete" class="spinner-gbl-div"> 
    <mat-spinner class="gbl-cls"></mat-spinner>
  </div>
  <div class="panel-container" *ngIf="loaded">
    <div class="panel-div" *ngFor="let product of productList">
      <mat-expansion-panel class="panel-cls"  expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h2 class="purple-clr">{{product}}</h2>
            <h4 class="padding-left-40">Assigned licenses: {{usedLicenseCount}} out of {{totalLicenses}}</h4>  
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="tableCls horiz-scrl">
          <form [formGroup] = "adminForm">
            <ng-container formArrayName="adminList"> 
              <table mat-table [dataSource]="dataSource">
                <caption>
                  <div class="submit-button floatLeft">
                    <button mat-fab extended class="btn-cls" (click)="addAdmin(product)" [disabled]="(totalLicenses - usedLicenseCount) < 1">Add User</button>
                  </div>
                  <div class="floatRight">
                  <mat-paginator #licPag [length]="adminList.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
                    aria-label="Select page of admins">
                  </mat-paginator>
                </div>
                </caption> <br>
                
                <ng-container matColumnDef="fName">
                  <th mat-header-cell *matHeaderCellDef> First Name </th>
                  <td mat-cell *matCellDef="let element let i = index" [formGroup]="element">
                    <div>
                      {{element.value.firstName}}
                    </div>
                  </td>
                  </ng-container>
            
                <ng-container matColumnDef="lName">
                  <th mat-header-cell *matHeaderCellDef> Last Name </th>
                  <td mat-cell *matCellDef="let element let i = index" [formGroup]="element" class="width27">
                    <div>
                      {{element.value.lastName}}
                    </div>
                  </td>
                </ng-container>
            
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef required-field> Email </th>
                    <td mat-cell *matCellDef="let element let i = index" [formGroup]="element" class="width27">
                    <div>
                      {{element.value.email}}
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="hasAccess">
                  <th mat-header-cell *matHeaderCellDef> Access Type </th>
                  <td mat-cell *matCellDef="let element let i = index" [formGroup]="element">
                    <div>
                      {{accessTypes[element.value.accessType]}}
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef> Action </th>
                  <td mat-cell *matCellDef="let element let i = index">
                    <span>
                    <mat-icon class="icon-cls" aria-hidden="false" matTooltip="Delete" fontIcon="delete"
                    (click)="deleteUser(i, product)" ></mat-icon>
                  </span>
                  <span>
                   <mat-icon class="icon-cls floatLeft paddingRight40" matTooltip="Edit" aria-hidden="false" 
                      fontIcon="edit" (click)="editUser(i, product)" [ngClass]="{'disable-icon': (totalLicenses - usedLicenseCount) < 1 && element.value.accessType==='Administrator'}"></mat-icon>                    
                  </span>
                  </td>
                </ng-container>
            
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true"></tr>
                <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
              
              </table>
            </ng-container>
          </form>
        </div>


        <ng-template #deleteUserDialog>
          <h1 mat-dialog-title>Delete User</h1>  
          <div mat-dialog-content class="horiz-scrl">
            Are you sure you want to remove user?
          </div>
          <mat-dialog-actions align="center">
              <button mat-fab extended class="btn-cls" (click)="deleteAdmin()" mat-dialog-close>Yes</button> 
              <button mat-fab extended class="btn-cls" mat-dialog-close>No</button> 
          </mat-dialog-actions>
        </ng-template>        

        <ng-template #addAdminDialog>
          <h1 mat-dialog-title *ngIf="action!=='edit'">Add User</h1>  
          <h1 mat-dialog-title *ngIf="action==='edit'">Manage Users</h1>  
          <div mat-dialog-content class="horiz-scrl"> <!-- -->
            <form [formGroup]="addAdminForm" class="padding-left-20">
              <div>
                <span>
                  <label class="pd-label required-field">First Name</label>
                  <div>
                    <mat-form-field>
                      <input  matInput formControlName="firstName" >
                    </mat-form-field>
                  </div>
                </span>
                <span>
                  <label class="pd-label required-field">Last Name</label>
                  <div>
                    <mat-form-field>
                      <input  matInput formControlName="lastName" >
                    </mat-form-field>
                  </div>
                </span>
                <span>
                  <label class="pd-label required-field">Email</label>
                  <div>
                    <mat-form-field>
                      <input  matInput formControlName="email" >
                      <mat-error *ngIf="emailForAdd?.hasError('alreadyExists')">
                        User or Email already exists
                      </mat-error>
                    </mat-form-field>
                  </div>
                </span>
                <span>
                  <b><label>Access Type</label></b><br/>
                  <div class="custom-control custom-radio" *ngFor="let item of accessTypesList">
                    <input [id]="item.code" type="radio" class="custom-control-input" [value]="item.code" name="accessType" formControlName="accessType">
                    <label class="custom-control-label" [for]="item.code">{{item.desc}}</label>
                  </div>      
                </span>
              </div>
            </form>
            <div class="msg-cls padding-left-20"> 
              {{msgText}}
            </div>
          </div>
          <mat-dialog-actions class="padding-left-40">
            <div class="submit-button">
              <button mat-fab extended class="btn-cls" [disabled]="disableSaveBtn()" 
                (click)="saveData()">Save</button> 
              <button mat-fab extended class="btn-cls" (click)="cancelAdd()">
                Cancel</button> 
            </div>
          </mat-dialog-actions>
        </ng-template>
      </mat-expansion-panel>
    </div>
    <div class="submit-button floatRight">
      <button mat-fab extended class="btn-cls" (click)="gotoCatalog()">Go to RBRVS DataManager</button>
    </div>
  </div>
 
</div>